import none from '../../img/leoLogo.png'

export const drinks=[
    {
      "id": "71",
      "title": "آب معدنی",
      "desciption": "",
      "price": "22",
      "image": none
    },
    {
      "id": "72",
      "title": "نوشابه",
      "desciption": "",
      "price": "45",
      "image": none
    },
    {
      "id": "73",
      "title": "دلستر",
      "desciption": "",
      "price": "65",
      "image": none
    },
    {
      "id": "74",
      "title": "انرژی زا",
      "desciption": "",
      "price": "80",
      "image": none
    },
    {
      "id": "75",
      "title": "لیوان یخ",
      "desciption": "",
      "price": "15",
      "image": none
    },
    {
      "id": "76",
      "title": "دوغ",
      "desciption": "",
      "price": "45",
      "image": none
    },
  ]